import React from 'react';
import { IndexRedirect, Route, Redirect } from 'react-router';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import { CollectSizesUrl } from 'swag-common/utils/urls/collect-sizes.url';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { SPECIAL_ROUTES } from 'swag-client-common/constants/app-special-routes.dynamic';
import { ProfilePassword } from '../components/routes/account/profile-password';
import { ProfileContainer } from '../containers/profile/profile-container';
import { handleLoginFailed } from './route-hooks/route-hooks-other.sendoso';
import { onProfilePasswordLeave, onWhatWeOfferEnter, requiredToBeLoggedIn, onSizeSubmissions, onSizeSubmissionsLeave, onSizeSelectionEnter, onSizeSelectionSuccessEnter, onInvitationEnter, onResellerAgreementPageEnter, onInventoryContractPageEnter } from './route-hooks/route-hooks';
const LazyTOS = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[TOS]" */'../components/routes/client/tos');
});
const LazyPrivacyPolicy = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[PrivacyPolicy]" */'../components/routes/client/privacy-policy');
});
const LazySizeSubmissions = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[SizeSubmissions]" */'../components/routes/account/size-submissions').then(module => ({
    default: module.SizeSubmissions
  }));
});
const LazySizeSelection = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[SizeSelection]" */'../components/routes/client/landing-size-selection').then(module => ({
    default: module.LandingSizeSelection
  }));
});
const LazySizeSelectionSuccess = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[SizeSelectionSuccess]" */'../components/routes/client/landing-size-selection-success').then(module => ({
    default: module.LandingSizeSelectionSuccess
  }));
});
const LazyWhatWeOffer = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[WhatWeOffer]" */'../components/routes/client/what-we-offer');
});
const LazyProductListing = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[ProductListing]" */'../components/routes/client/product-listing');
});
const LazyCartUnavailable = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[CartPlaced]" */'../components/routes/client/cart-unavailable').then(({
    CartPlaced
  }) => ({
    default: CartPlaced
  }));
});
const LazyCommitmentToAccessibility = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[CommitmentToAccessibility]" */'../components/routes/client/commitment-to-accessibility').then(module => ({
    default: module.CommitmentToAccessibility
  }));
});
const LazyInventoryContract = /*#__PURE__*/React.lazy(() => {
  return import( /* webpackChunkName: "[InventoryContract]" */'../components/routes/client/inventory-contract').then(module => ({
    default: module.InventoryContract
  }));
});
export const OtherRoutes = ({
  store,
  dispatch
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: APP_ROUTES.ALL_SWAG
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: SPECIAL_ROUTES.PREBUILT_CART_MODE,
    to: APP_ROUTES.CART
  }), /*#__PURE__*/React.createElement(Route, {
    path: "login-failed/:code",
    onEnter: handleLoginFailed(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.ACCOUNT_PROFILE,
    component: ProfileContainer,
    onEnter: requiredToBeLoggedIn(store)
  }, /*#__PURE__*/React.createElement(Route, {
    path: "password",
    component: ProfilePassword,
    onLeave: onProfilePasswordLeave(store, dispatch)
  })), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.PRIVACY_POLICY,
    component: props => /*#__PURE__*/React.createElement(LazyPrivacyPolicy, props),
    onEnter: onResellerAgreementPageEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.TOS,
    component: props => /*#__PURE__*/React.createElement(LazyTOS, props),
    onEnter: onResellerAgreementPageEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.COMMITMENT_TO_ACCESSIBILITY,
    component: props => /*#__PURE__*/React.createElement(LazyCommitmentToAccessibility, props),
    onEnter: instantScrollTop
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.SIZE_SUBMISSIONS,
    component: props => /*#__PURE__*/React.createElement(LazySizeSubmissions, props),
    onEnter: onSizeSubmissions(store, dispatch),
    onLeave: onSizeSubmissionsLeave(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: CollectSizesUrl.getCollectSizesSubmitLanding({
      link: ':link'
    }),
    component: props => /*#__PURE__*/React.createElement(LazySizeSelection, props),
    onEnter: onSizeSelectionEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: CollectSizesUrl.getCollectSizesSubmitSuccess({
      link: ':link'
    }),
    component: props => /*#__PURE__*/React.createElement(LazySizeSelectionSuccess, props),
    onEnter: onSizeSelectionSuccessEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: APP_ROUTES.WHAT_WE_OFFER,
    component: props => /*#__PURE__*/React.createElement(LazyWhatWeOffer, props),
    onEnter: onWhatWeOfferEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${APP_ROUTES.INVITATION}/:inviteId`,
    component: props => /*#__PURE__*/React.createElement(LazyProductListing, props),
    onEnter: onInvitationEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: SPECIAL_ROUTES.CART_UNAVAILABLE,
    component: props => /*#__PURE__*/React.createElement(LazyCartUnavailable, props)
  }), /*#__PURE__*/React.createElement(Route, {
    path: SPECIAL_ROUTES.INVENTORY_CONTRACT,
    component: props => /*#__PURE__*/React.createElement(LazyInventoryContract, props),
    onEnter: onInventoryContractPageEnter(store, dispatch)
  }));
};